import styled from 'styled-components';

export const Wrapper = styled.div`
	position: relative;

	@media (max-width: 992px) {
		margin-top: 62px;
	}
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const Title = styled.h2`
	font-weight: 700;
	font-size: 48px;
	color: ${({ theme }) => theme.colors.text.title};
	line-height: 1;
	letter-spacing: -0.01em;

	@media (max-width: 992px) {
		font-size: 32px;
		line-height: 1.2;
	}
`;

export const Banner = styled.div<{ $bannerBg: string; $bannerBgMob: string; $isCom2: boolean }>`
	background-image: url(${({ $bannerBg }) => $bannerBg});
	background-repeat: no-repeat;
	background-size: cover;
	border-radius: 4px;
	width: 100%;
	max-height: 520px;
	height: 100%;
	display: flex;
	gap: 10px;
	justify-content: space-between;
	align-items: center;
	place-self: center;
	background-position-x: left;
	background-position-y: top;
	padding-left: 40px;

	@media (max-width: 992px) {
		flex-direction: column;
		max-height: inherit;
		padding-left: 0;
		padding-top: 30px;

		${({ theme, $isCom2, $bannerBgMob }) =>
			$isCom2 ? `background-image: url('${$bannerBgMob}');` : `background: ${theme.gradient.backgroundProfile};`}
	}
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	align-items: baseline;
	max-width: 380px;
	width: 100%;

	@media (max-width: 992px) {
		max-width: inherit;
		text-align: center;
		align-items: center;
	}
`;

export const BannerTitle = styled.div`
	font-size: 56px;
	font-weight: 700;
	letter-spacing: 0;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 1800px) {
		font-size: 48px;
	}

	@media (max-width: 992px) {
		text-align: center;
	}
`;

export const Tags = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 14px;
	margin: 16px 0 20px;
	@media (max-width: 992px) {
		justify-content: center;
	}
`;

export const Tag = styled.div`
	font-weight: 500;
	font-size: 14px;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	border-radius: 100px;
	width: auto;
	height: 31px;
	background: ${({ theme }) => theme.colors.transparent.light10};
	display: flex;
	align-items: center;
	padding: 10px;
`;

export const BannerImg = styled.img`
	max-width: 675px;
	max-height: 525px;
	width: 100%;
	height: 100%;
	padding: 20px 0;
`;
